import { connect } from 'react-redux';
import { css } from 'aphrodite';
import { Field, FormProps, reduxForm } from 'redux-form';
import * as _ from 'lodash';
import * as React from 'react';

import * as formUtils from 'login-utils/formUtils';
import ErrorMessage from 'login-components/Common/Notifications/ErrorMessage/ErrorMessage';
import InputMap from 'login-components/Common/Inputs/InputMap';
import PrimaryButton from 'login-components/Common/Buttons/PrimaryButton';
import { paneFormStyles } from 'login-components/Common/PaneLayout/paneStyles';

export const CORE_PASSWORD_PROPERTY = 'password';
const FORM_ERROR_ID = 'ChoosePasswordForm-formError';

const inputs: FormInput[] = [
  {
    ...InputMap.PasswordInputWithStrength,
    name: CORE_PASSWORD_PROPERTY,
    identifier: 'password',
    label: 'New password',
  },
  {
    ...InputMap.PasswordInput,
    name: 'password2',
    identifier: 'password again',
    label: 'Confirm new password',
    validateMatch: CORE_PASSWORD_PROPERTY,
  },
];

interface PasswordFormProps extends FormProps<any, any, any> {
  submitPassword: (any) => Promise<void>;
}

export class ChoosePasswordForm extends React.Component<PasswordFormProps, {}> {
  render() {
    // handleSubmit always exists although typed optional
    const { handleSubmit, submitPassword, error, submitting } = this.props;
    return (
      <form className={css(paneFormStyles.container)} noValidate onSubmit={handleSubmit!(submitPassword)}>
        <fieldset>
          {inputs.map(input => {
            return (
              // eslint-disable-next-line react/jsx-key
              <div className={css(paneFormStyles.fieldWrapper)}>
                <Field key={input.name} {...input} hidePlaceholder />
              </div>
            );
          })}
        </fieldset>
        {error && (
          <div className={css(paneFormStyles.errorWrapper)}>
            <ErrorMessage errorText={error} errorId={FORM_ERROR_ID} />
          </div>
        )}
        <div className={css(paneFormStyles.buttonDisplay, paneFormStyles.buttonPadding)}>
          <PrimaryButton isWide buttonId="it-ChoosePasswordSubmit" disabled={submitting} text="Continue" />
        </div>
      </form>
    );
  }
}

const ReduxFormConnectedChoosePasswordForm = reduxForm<any, any>({
  form: 'choosePassword',
  validate: _.partial(formUtils.validate, inputs) as () => any,
  onSubmitFail: syncErrors => formUtils.focusOnSubmitFail(syncErrors, FORM_ERROR_ID),
})(ChoosePasswordForm);

const ConnectedChoosePasswordForm = connect()(ReduxFormConnectedChoosePasswordForm);

export default ConnectedChoosePasswordForm;
